import React, { Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import Loader from "components/Loader";
import AboutUs from "components/layout/AboutUs";
import SidebarInsurances from "components/layout/outer-header/SidebarInsurances";
import { SidebarWorkingConditions } from "components/layout/outer-header/SidebarWorkingConditions";
// import Business from "components/layout/outer-header/business/Business";

import HowItWorks from "views/HowItWorks";
import BussinesInfo from "components/layout/outer-header/BussinesInfo";
import CompareDiffForms from "components/layout/outer-header/CompareDiffForms";
import WorkingAsFreelancer from "components/layout/outer-header/WorkingAsFreelancer";
import InvoiceWithoutCompany2025 from "components/layout/outer-header/InvoiceWithoutCompany2025";
import CompanyReview from "views/dashboard/seo-files/company-review/CompanyReview";
import { InvoicingSelfEmployed } from "views/dashboard/seo-files/InvoicingSelfEmployed";
import { FreelanceFreelancing } from "views/dashboard/seo-files/FreelanceFreelancing";
import ApprovalNotifyPage from "components/ApprovalNotifyPage";
import Unsubscribed from "components/Unsubscribed";
import AuthorizedForReminder from "components/AuthorizedForReminder";
import CookiesPage from "components/layout/outer-header/cookiesPage";
import Ambassador from "components/layout/Ambassador";
import SelfEmployment from "components/layout/outer-header/SelfEmployment";
import InfoInspiration from "components/layout/outer-header/InfoInspiration";
import Negotiation from "components/layout/outer-header/Negotiation";
import GiggerVsInvozio from "views/dashboard/seo-files/comparison/GiggerVsInvozio";
import FrilansVsInvozio from "views/dashboard/seo-files/comparison/FrilansVsInvozio";
import CoolCompanyVsInvozio from "views/dashboard/seo-files/comparison/CoolCompanyVsInvozio";
import Error from "views/Error";
import DashboardView from "views/dashboard";
// import PrivateCareInsurance from "components/layout/outer-header/PrivateCareInsurance";
import PensionInsurance from "components/layout/outer-header/PensionInsurance";
import ManinHealthInsurance from "components/layout/outer-header";
import HealthInsurance from "components/layout/outer-header/HealthInsurance";
import { InvoiceAsConsultant } from "components/layout/outer-header/InvoiceAsConsultant";
// import { InvoiceWithoutCompany } from "components/layout/outer-header/InvoiceWithoutCompany";
import { LOCALES } from "common/constants";
import { lazyWithRetry } from "common/lazyWithRetry";
import { useLocalizedRoutes } from "../v2/hooks/useLocalizedRoutes";
import { LandingPage } from "./../v2/pages/landing-page.page";
import { FaqPage } from "../v2/pages/faq-page.page";
import { FreelanceLifePage } from "./../v2/pages/freelance-life.page";
import { SelfEmploymentPage } from "./../v2/pages/self-employment.page";
import { WorkConditionPage } from "../v2/pages/work-condition.page.tsx";
import { BusinessOrInvoicePage } from "./../v2/pages/business-or-invoice.page";
import NewsPage from "./../v2/pages/news-page.page";
import NewsDetailPage from "../v2/pages/news-detail.page";
import BookKeepingPage from "./../v2/pages/book-keeping-page.page";
import FreelancingGuide from "./../v2/pages/freelancing-guide-page.page";
import { ContactUsPage } from "../v2/pages/contact-us.page";
import { Business } from "../v2/pages/landing-page-bussiness.page";
import { AmbassadorPage } from "../v2/pages/ambassador-page.page";
import { InsurancePageMain } from "../v2/pages/insurance-page.tsx";
// import { PrivateInsurancePageMain } from "../v2/pages/private-insurance.page";
import SelfEmployedInvoicingPage from "../v2/pages/self-employed-invoicing.page.tsx";
// import FreelanceIncomePotentialPage from "../v2/pages/freelance-income-potential.page";
import AboutUsPage from "../v2/pages/about-us.page";
import HowItWorksPage from "../v2/pages/how-it-works.page";
import FeaturesPage from "../v2/pages/features.page";
import PrivateInsurancePageMain from "../v2/pages/private-insurance-page";
import InsurancePageMain from "../v2/pages/insurance-page";
import PensionPagePage from "../v2/pages/pension-page";
import HealthInsurancePage from "../v2/pages/healthInsurance-page";
import FreelanceIncomePotentialPage from "../v2/pages/freelance-income-potential.page";
import PrivacyPolicyPage from "../v2/pages/privacy-policy.page";
// import { LoyaltyProgramPage } from "../v2/pages/loyalty-program.page";
// import RegistrationFormPage from "../v2/pages/registration-form.page";
const Faq = lazyWithRetry(() => import("../views/dashboard/Faq"));
// const DashboardView = lazyWithRetry(() => import("../views/dashboard"));
const HomePage = lazyWithRetry(() => import("../views/index"));

export const Router = ({ mobileScreen, dashboardFooter, language }) => {
  const { routes } = useLocalizedRoutes();
  return (
    <Routes>
      {/* Mobile Screen Pages Start */}
      <Route
        exact
        path="/mobile_faq"
        element={
          <Suspense
            fallback={
              <div>
                <Loader />
              </div>
            }
          >
            <Faq mobileScreen={mobileScreen} />
          </Suspense>
        }
      />
      <Route
        exact
        path="/mobile_about_us"
        element={<AboutUs mobileScreen={mobileScreen} />}
      />
      <Route
        exact
        path="/mobile_Insurance_admin"
        element={<SidebarInsurances mobileScreen={mobileScreen} />}
      />
      <Route
        exact
        path="/mobile_goodworking_conditions"
        element={<SidebarWorkingConditions mobileScreen={mobileScreen} />}
      />
      <Route
        exact
        path="/mobile_business_solution"
        element={<Business dashboardFooter={dashboardFooter} />}
      />
      {/* Mobile Screen Pages End */}

      <Route
        exact
        path="/"
        element={
          <Suspense
            fallback={
              <div>
                <Loader />
              </div>
            }
          >
            {/* <HomePage dashboardFooter={dashboardFooter} /> */}
            <LandingPage />
          </Suspense>
        }
      />

      <Route
        exact
        path={routes.function}
        element={<FeaturesPage dashboardFooter={dashboardFooter} />}
      />

      <Route
        exact
        path="/faq"
        element={
          <Suspense
            fallback={
              <div>
                <Loader />
              </div>
            }
          >
            {/* <Faq dashboardFooter={dashboardFooter} /> */}
            <FaqPage />
          </Suspense>
        }
      />
      <Route
        exact
        path={
          language === LOCALES.EN_US ? "/how-works-invozio" : "/hur-fungerar-invozio"
        }
        element={<HowItWorksPage dashboardFooter={dashboardFooter} />}
      />

      <Route
        exact
        path={language === LOCALES.EN_US ? "/about-invozio" : "/om-invozio"}
        element={<AboutUsPage dashboardFooter={dashboardFooter} />}
      />
      <Route
        exact
        path={language === LOCALES.EN_US ? "/contact-us" : "/kontakta-oss"}
        element={
          <Suspense
            fallback={
              <div>
                <Loader />
              </div>
            }
          >
            <ContactUsPage />
          </Suspense>
        }
      />
      <Route
        exact
        path={language === LOCALES.EN_US ? "/dashboard/*" : "/instrumentbrada/*"}
        element={<DashboardView dashboardFooter={dashboardFooter} />}
      />

      <Route
        exact
        path={
          language === LOCALES.EN_US ? "/health-insurance-main" : "/sjukforsakring-huvud"
        }
        element={<HealthInsurancePage dashboardFooter={dashboardFooter} />}
      />

      <Route
        exact
        path={language === LOCALES.EN_US ? "/health-insurance" : "/sjukforsakring"}
        element={<HealthInsurancePage dashboardFooter={dashboardFooter} />}
      />

      <Route
        exact
        path={routes.privateCareInsurance}
        element={<PrivateInsurancePageMain  />}
      />

      <Route
        exact
        path={language === LOCALES.EN_US ? "/pension" : "/pension"}
        element={<PensionPagePage dashboardFooter={dashboardFooter} />}
      />

      <Route
        exact
        path="/external-help-with-payroll-management"
        element={<BussinesInfo dashboardFooter={dashboardFooter} />}
      />
      <Route
        exact
        path={
          language === LOCALES.EN_US
            ? "/freelance-consultant-salary-invoice-without-a-company"
            : "/frilans-konsult-lon-fakturera-utan-foretag"
        }
        element={<BusinessOrInvoicePage dashboardFooter={dashboardFooter} />}
      />
      <Route
        exact
        path={
          language === LOCALES.EN_US
            ? "/invoicing-without-company-2025"
            : "/fakturering-utan-foretag-2025"
        }
        element={<InvoiceWithoutCompany2025 dashboardFooter={dashboardFooter} />}
      />
      {/* <Route
        exact
        path={
          language === LOCALES.EN_US
            ? "/working-as-a-freelancer-and-invoicing-without-tax-registration"
            : "/att-jobba-som-frilansare-och-fakturera-utan-fskatt"
        }
        element={<WorkingAsFreelancer dashboardFooter={dashboardFooter} />}
      /> */}
      <Route
        exact
        path={routes.workingFreelancer}
        element={<FreelanceLifePage />}
      />
      <Route
        exact
        path="/recension-av-faktura-utan-foretag-frilansfinans-coolcompany-gigger"
        element={<CompanyReview />}
      />
      <Route exact path="/gigger-vs-Invozio" element={<GiggerVsInvozio />} />
      <Route
        exact
        path="/frilans-finans-vs-Invozio"
        element={<FrilansVsInvozio />}
      />
      <Route
        exact
        path="/cool-company-vs-Invozio"
        element={<CoolCompanyVsInvozio />}
      />
      <Route
        exact
        path={
          language === LOCALES.EN_US
            ? "/how-much-should-I-invoice-as-a-freelancer"
            : "/hur-mycket-ska-jag-fakturera-som-frilansare"
        }
        element={<FreelanceIncomePotentialPage  dashboardFooter={dashboardFooter} />}
      />
      <Route
        exact
        path={
          language === LOCALES.EN_US
            ? "/from-invoice-to-negotiation"
            : "/fran-faktura-till-forhandling"
        }
        element={<Negotiation dashboardFooter={dashboardFooter} />}
      />
      <Route
        exact
        path={language === LOCALES.EN_US ? "/business" : "/foretag"}
        // element={<Business dashboardFooter={dashboardFooter} />}
        element={<Business />}
      />
      <Route
        exact
        path={routes.selfEmployment}
        element={<SelfEmploymentPage dashboardFooter={dashboardFooter} />}
      />
      <Route
        exact
        path={routes.startBusiness}
        element={<WorkConditionPage dashboardFooter={dashboardFooter} />}
      />
      <Route
        exact
        path={routes.invoiceWithoutCompany}
        element={<BusinessOrInvoicePage />}
      />
      <Route
        exact
        path={routes.ambassador}
        element={<AmbassadorPage dashboardFooter={dashboardFooter} />}
      />
      <Route
        exact
        path="/cookies"
        element={<PrivacyPolicyPage dashboardFooter={dashboardFooter} />}
      />
      <Route exact path="/error" element={<Error />} />

      <Route
        exact
        path={language === LOCALES.EN_US ? "/unsubscribed" : "/avprenumererad"}
        element={<Unsubscribed />}
      />
      <Route
        exact
        path={language === "en" ? "/authorize-reminder" : "/auktorisera-påminnelse"}
        element={<AuthorizedForReminder />}
      />
      <Route
        exact
        path={
          language === LOCALES.EN_US ? "/approval-notify" : "/godkannande-meddelande"
        }
        element={<ApprovalNotifyPage />}
      />
      {/* <Route
        exact
        path={
          language === LOCALES.EN_US
            ? "/freelance-freelancing"
            : "/frilans-frilansarbete"
        }
        element={<FreelanceFreelancing dashboardFooter={dashboardFooter} />}
      /> */}
      <Route
        exact
        path={routes.freelancingGuide}
        element={<FreelancingGuide />}
      />
      {/* <Route
        exact
        path={
          language === LOCALES.EN_US
            ? "/freelance-income-potential"
            : "/frilans-inkomstpotential"
        }
        element={<FreelanceIncomePotentialPage dashboardFooter={dashboardFooter} />}
      /> */}

      <Route
        exact
        path={
          language === LOCALES.EN_US
            ? "/invoice-as-consultant-salary"
            : "/fakturera-som-konsult-lon"
        }
        element={<InvoiceAsConsultant dashboardFooter={dashboardFooter} />}
      />
      <Route
        exact
        path={routes.newsDetail}

        element={<NewsDetailPage />}
      />
      <Route
        exact
        path={routes.news}
        element={<NewsPage dashboardFooter={dashboardFooter} />}
      />
      <Route
        exact
        path={routes.bookKeeping}
        element={<BookKeepingPage />}
      />
      {/* <Route
        exact
        path={routes.loyaltyProgram}
        element={<LoyaltyProgramPage />}
      /> */}
      <Route
        exact
        path={routes.invoicingIndividual}
        element={<SelfEmployedInvoicingPage dashboardFooter={dashboardFooter} />}
      />

      <Route
        exact
        // path={language === LOCALES.EN_US ? "/insurance" : "/forsakring"}
        path={routes.insurance}
        element={<InsurancePageMain dashboardFooter={dashboardFooter} />}
      />
      <Route
        exact
        // path={language === LOCALES.EN_US ? "/insurance" : "/forsakring"}
        path={routes.insurance}
        element={<InsurancePageMain dashboardFooter={dashboardFooter} />}
      />
    </Routes>
  );
};
